/**
 * Created by slipkinem on 5/25/2017.
 */
'use strict'

// 设置网页的标题，兼容微信
import PlatformInteractionUtil from "@/utils/PlatformInteractionUtil";

export default function (title) {
  document.title = title
  let ua = navigator.userAgent
  if (/\bMicroMessenger\/([\d.]+)/.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    var i = document.createElement('iframe')
    i.src = '/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
  PlatformInteractionUtil.setNavTitle(title)
}
